import { API_BASE, PUBLIC_BASE_URL } from "../config/constants";

export const WHATSAPP_INVOICE_ENDPOINT = `${API_BASE}/whatsapp/invoice/send-v2`;
export const POS_SEND_WHATSAPP_BILLING_ON_CREATE_ORDER_KEY =
  "pos_send_whatsapp_billing_on_create_order";

export const normalizeWhatsAppInput = (rawValue) => {
  const digits = String(rawValue || "").replace(/\D/g, "");
  if (digits.length === 12 && digits.startsWith("91")) {
    return digits.slice(-10);
  }
  if (digits.length === 10) {
    return digits;
  }
  return digits.slice(-10);
};

const parsePositiveInteger = (value) => {
  const raw = String(value || "").trim();
  if (!/^\d+$/.test(raw)) return null;
  const parsed = Number.parseInt(raw, 10);
  return Number.isInteger(parsed) && parsed > 0 ? parsed : null;
};

export const buildInvoiceLink = ({ orderId, restaurantId }) => {
  const normalizedOrderId = parsePositiveInteger(orderId);
  const normalizedRestaurantId = parsePositiveInteger(restaurantId);
  if (!normalizedOrderId || !normalizedRestaurantId) {
    return "";
  }
  return `${PUBLIC_BASE_URL}/?bill=${normalizedOrderId}-${normalizedRestaurantId}`;
};

export const buildAutoSendWhatsAppInvoicePayload = ({
  enabled,
  isEditingExisting,
  customerSelected,
  orderId,
  restaurantId,
  customerMobile,
  customerName,
}) => {
  if (!enabled || isEditingExisting || !customerSelected) {
    return null;
  }

  const normalizedOrderId = parsePositiveInteger(orderId);
  const normalizedRestaurantId = parsePositiveInteger(restaurantId);
  const normalizedMobile = normalizeWhatsAppInput(customerMobile);

  if (!normalizedOrderId || !normalizedRestaurantId || normalizedMobile.length !== 10) {
    return null;
  }

  const payload = {
    orderId: normalizedOrderId,
    customerMobile: normalizedMobile,
    invoiceLink: buildInvoiceLink({
      orderId: normalizedOrderId,
      restaurantId: normalizedRestaurantId,
    }),
  };

  const trimmedCustomerName = String(customerName || "").trim();
  if (trimmedCustomerName) {
    payload.customerName = trimmedCustomerName;
  }

  return payload;
};

export const sendMetaWhatsAppInvoice = async ({
  orderId,
  customerMobile,
  customerName,
  invoiceLink,
}) => {
  const body = {
    order_id: orderId,
    customer_mobile: customerMobile,
  };

  if (customerName) {
    body.customer_name = customerName;
  }

  if (invoiceLink) {
    body.invoice_link = invoiceLink;
  }

  const response = await fetch(WHATSAPP_INVOICE_ENDPOINT, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  });

  let result = null;
  try {
    result = await response.json();
  } catch {
    result = null;
  }

  if (!response.ok || !result?.success) {
    const error = new Error(
      result?.message || "Unable to send WhatsApp invoice"
    );
    error.status = response.status;
    error.response = result;
    error.requiresRecharge = !!result?.requires_recharge;
    error.credits = result?.credits || null;
    throw error;
  }

  return result;
};

export const maybeSendAutoWhatsAppInvoice = async (
  options,
  sendInvoice = sendMetaWhatsAppInvoice
) => {
  const payload = buildAutoSendWhatsAppInvoicePayload(options);
  if (!payload) {
    return false;
  }

  try {
    await sendInvoice(payload);
    return true;
  } catch (error) {
    console.error(
      "Auto WhatsApp invoice send failed",
      error?.message || error
    );
    return false;
  }
};
